// extracted by mini-css-extract-plugin
export default {"gridTile":"app-assets-javascripts-components-deliveryAccountCard-deliveryAccountCard__gridTile--yhvOy"};